import * as packageJson from '../../../../package.json';

/**
 * Will be replaced during build time
 */
const buildInfo = {
  buildNumber:
    import.meta.env['VITE_APP_ENV'] === 'development'
      ? new Date().toISOString()
      : '2026-11-04T10:31:47Z',
  buildSystem:
    import.meta.env['VITE_APP_ENV'] === 'development'
      ? 'local'
      : 'ci',
  version:
    import.meta.env['VITE_APP_ENV'] === 'development'
      ? packageJson.version
      : '2026.11.03',
};

export function getAppInformation() {
  return {
    ...buildInfo,
    applicationName: import.meta.env['VITE_APP_NAME'] || 'not-set',
  };
}

function center(text: string, lineLength: number) {
  const diff = lineLength - text.length;
  const padding = Math.floor(diff / 2);
  return ''.padStart(padding, ' ') + text;
}

export function logHiringMessage() {
  const style = 'color: #041239; line-height: 1.5;';
  const hiringText = '👉 We are hiring! 😎';
  const hiringUrl = 'https://www.linkedin.com/company/72180545';
  const n = [
    [...'███    ██'.split('')],
    [...'████   ██'.split('')],
    [...'██ ██  ██'.split('')],
    [...'██  ██ ██'.split('')],
    [...'██   ████'.split('')],
  ];
  const flippedN = n.map((row) => [...row].reverse());

  // Add new texts here to figure out the longest line. Needed for centering
  const lineLength = Math.max(
    hiringText.length,
    hiringUrl.length,
    n[0].length * 2 + 1
  );

  const lines: string[] = [' '];

  for (let line = 0; line < n.length; line++) {
    const lineText = n[line].join('') + ' ' + flippedN[line].join('');
    lines.push(center(lineText, lineLength));
  }
  lines.push('');
  lines.push(center(hiringText, lineLength));
  lines.push(center(hiringUrl, lineLength));
  lines.push(' ');

  // oxlint-disable-next-line no-console
  console.log('%c' + lines.join('\n'), style);
}

export function logVersion() {
  const { version, applicationName, buildNumber } = getAppInformation();
  const string = ` 💻 ${applicationName} v${version} (${buildNumber})`;
  const length = string.length;

  const line = ''.padStart(length, '-');
  const message = `%c${line}\n${center(string, length)}\n${line}`;

  // oxlint-disable-next-line no-console
  console.log(message, 'font-weight: bold;');
}
